<div class="quantityContainer">
    <button matRipple [matRippleColor]="rippleColor" class="quantity" (click)="updateQuantity(true)">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
      </svg>
    </button>

    <div style="padding: 0; margin: 0;text-align: center; font-size:15px;">
      {{itemQuantity}}
    </div>
    <button matRipple [matRippleColor]="rippleColor" class="quantity" (click)="updateQuantity(false)">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16">
        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"/>
      </svg>
    </button>


  </div>
